'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('TargetAudience', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(apiSettings.baseUri + 'v1/targetaudiences/:id', { id: '@id' }, {
		'list': {
			method: 'GET',
			isArray: false,
			params: {
				page: 1,
				pageSize: apiSettings.defaultPageSize,
				keyword: ''
			}
		},
		'listIds': {
			url: apiSettings.baseUri + 'v1/targetaudiences/list/ids',
			method: 'GET',
			isArray: true
		}
	});
}]);